module.exports = __webpack_public_path__ + "static/iot-device-b06004e430f779ad87e133cde582f9ad.png";